import { useState, type ReactNode } from 'react';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';
import { Button } from '@/components/Button';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';

export type BulkActionType =
  'changeOrganizationUser' | 'addTag' | 'removeTag' | 'updateData' | 'deleteData';

export interface BulkActionItem<T extends string = BulkActionType> {
  action: T;
  label: string;
  icon: ReactNode;
}

interface Props<T extends string> {
  items: BulkActionItem<T>[];
  onAction: (action: T) => void;
}

export default function BulkActionsPopover<T extends string>({ items, onAction }: Props<T>) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button color="secondary" size="md" active={isOpen}>
          一括操作
          {isOpen ? (
            <MdArrowDropUp className="size-icon-sm" />
          ) : (
            <MdArrowDropDown className="size-icon-sm" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-auto rounded-sm p-0 shadow-layer3">
        <div className="flex flex-col">
          {items.map(({ action, label, icon }) => (
            <button
              key={action}
              type="button"
              className="flex h-xxl items-center gap-xs border-none bg-transparent px-md py-xs text-body-sm text-main hover:bg-gray"
              onClick={() => {
                onAction(action);
                setIsOpen(false);
              }}
            >
              {icon}
              <span className="font-bold">{label}</span>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
